<script setup lang="ts">
import type { ElementNode, MarkdownAstNode, TextNode } from "../disko/rich-text/streaming-markdown";

const props = defineProps<{
  node: MarkdownAstNode;
  /** tag of the parent element – used for context‑sensitive rendering */
  parentTag?: string;
}>();

const isText = (n: MarkdownAstNode): n is TextNode => n.type === "text";
const isEl = (n: MarkdownAstNode): n is ElementNode => "children" in n;

// we don't actually need the attrs right now, but leaving this here in case we want it later.
/** Convert the `attrs` tuple array into an object for v‑bind. */
// const attrObject = computed<Record<string, string>>(() => {
//   const ret = isEl(props.node) && props.node.attrs ? Object.fromEntries(props.node.attrs) : {}
//   console.log("attrObject", JSON.stringify(ret, null, 2));
//   return ret;
// })
</script>

<template>
  <br v-if="isText(props.node) && props.node.content.length === 0" />
  <span v-else-if="isText(props.node)">
    {{ props.node.content }}
  </span>

  <MarkdownItNode
    v-else-if="isEl(props.node) && props.node.tag === '' && props.node.children.length === 1 && ['ul', 'ol'].includes((props.node.children[0] as ElementNode).tag)"
    :node="(props.node.children[0] as ElementNode)"
  />

  <template v-else-if="isEl(props.node) && props.node.tag === 'p' && props.parentTag === 'li'">
    <MarkdownItNode
      v-for="(child, idx) in props.node.children"
      :key="idx"
      :node="child"
      parent-tag="p"
    />
  </template>

  <component
    :is="isEl(props.node) ? props.node.tag || 'div' : 'div'"
    v-else
  >
    <MarkdownItNode
      v-for="(child, idx) in (props.node as ElementNode).children"
      :key="idx"
      :node="child"
      :parent-tag="(props.node as ElementNode).tag"
    />
  </component>
</template>
